import React from "react";

export const MetadataRow: React.FC<{ icon: React.ReactNode; label: string; value:string }> = ({ icon, label, value }) => (
    <div className="flex items-center text-slate-600">
        {icon}
        <span className="text-sm mr-2">{label}</span>
        <span className="text-sm font-medium">{value}</span>
    </div>
);